import { TicketFormScopeTypeMap, TicketSystemFieldsKey } from '../../model/types';

export const baseAgentFormSystemFieldKeyList = [
    TicketSystemFieldsKey.formId,
    TicketSystemFieldsKey.subject,
    TicketSystemFieldsKey.status,
    TicketSystemFieldsKey.requester,
    TicketSystemFieldsKey.assignee,
    TicketSystemFieldsKey.emailCc,
    TicketSystemFieldsKey.creator
];

export const baseEndUserFormSystemFieldKeyList = [
    TicketSystemFieldsKey.formId,
    TicketSystemFieldsKey.subject,
    TicketSystemFieldsKey.description,
    TicketSystemFieldsKey.attachments,
    TicketSystemFieldsKey.untrusted_end_user
];
export const baseDealFormSystemFieldKeyList = [
    TicketSystemFieldsKey.stage,
    TicketSystemFieldsKey.result,
    TicketSystemFieldsKey.lossReasons,
    TicketSystemFieldsKey.unqualifiedReasons,
    TicketSystemFieldsKey.source,
    TicketSystemFieldsKey.valueAmount,
    TicketSystemFieldsKey.winLikelihoodProbability,
    TicketSystemFieldsKey.expectedCloseDate,
    TicketSystemFieldsKey.lastCall,
    TicketSystemFieldsKey.nextCall,
    TicketSystemFieldsKey.addedOn
];

export const baseSystemFieldKeyList = {
    [TicketFormScopeTypeMap.DEAL]: [
        ...new Set([
            ...baseAgentFormSystemFieldKeyList,
            ...baseEndUserFormSystemFieldKeyList,
            ...baseDealFormSystemFieldKeyList
        ])
    ],
    [TicketFormScopeTypeMap.TICKET]: [
        ...new Set([...baseAgentFormSystemFieldKeyList, ...baseEndUserFormSystemFieldKeyList])
    ]
};

export enum SystemFieldPrefixMap {
    TICKET = 'ts.',
    USER = 'us.',
    ORGANIZATION = 'os.',
    DEAL = 'dd.'
}
export enum CustomFieldCategoryMap {
    ticket = 'ticket',
    user = 'user',
    organization = 'organization',
    deal = 'deal',
    import = 'import'
}
export enum CustomFieldPrefixMap {
    ticket = 'tu',
    user = 'uu',
    organization = 'ou',
    deal = 'du',
    import = 'tiz'
}
